<template>
    <div id="chat" class="x-tab d-block" v-if="this.tab == 'chat'">
        <ul class="messages">
            <li v-for="chat in this.chat_messages" :class="chat.class_name">
                <span class="time-stamp" v-if="chat.time_string">{{chat.time_string}}</span>
                <a href="javascript:void(0)" v-if="chat.username" @click="doOpenUser(chat.user_id)">
                    <span :class="chat.role.toLowerCase() == 'admin' ? 'text-danger' : 'username'">{{utils.maskedUsername(chat.username, state.display_masked_username)}}</span>
                </a>
                <span>:</span>
                <span class="msg-body" v-html="chat.message_html"></span>
            </li>
        </ul>
        <div class="chat-input-container">
            <input class="chat-input" :placeholder="!this.state.username ? '채팅을 이용하려면 로그인이 필요합니다...' : ''" :disabled="!this.state.username || this.state.user_class == 'DEMO'" @keydown.13="sendMessage" />
            <!-- TODO: 채팅 채널 사용 시
            <div id="chat-channel-selector" class="noselect">
                <button type="button" class="chat-channel-plus" v-on:click="toggleDisplayChannels()"><i class="fa fa-comments text-white"></i></button>
            </div>
            -->
        </div>
    </div>
</template>

<script>
    const Autolinker = require('autolinker').default;

    export default {
        name: "chat-history",
        props: ['state', 'tab'],
        data: function()
        {
            let localStorage = {};
            try {
                localStorage = localStorage['ignored_client_list'] ? JSON.parse(localStorage['ignored_client_list']) : {};
            } catch (e) {}

            return {
                utils: utils,
                chat_max_length: 500,
                chat_messages: [],
                bots_display_mode: 'normal', //normal || greyed || none
                ignored_client_list: localStorage,
            };
        },
        created()
        {
            EventBus.$on('connected', this.updateChatMessages);
            EventBus.$on('update_chat_messages', this.updateChatMessages);
        },
        beforeDestroy()
        {
            EventBus.$off('connected', this.updateChatMessages);
            EventBus.$off('update_chat_messages', this.updateChatMessages);
        },
        mounted()
        {

        },
        beforeUpdate()
        {
            // console.log('tabs-selector before update');
        },
        updated()
        {
            // console.log('tabs-selector updated');
            $('.messages').scrollTop($('.messages').prop('scrollHeight'));
        },
        methods: {
            toggleDisplayChannels()
            {

            },
            doOpenUser(user_id)
            {
                this.state.modals.user_stats.display = true;
                this.state.modals.user_stats.data.user_id = user_id;
            },
            updateChatMessages()
            {
                let messages = [];
                for (let i = 0; i < this.state.chat_messages.length; i++) {
                    messages.push(this.renderMessage(this.state.chat_messages[i]));
                }
                this.chat_messages = _.compact(messages);
            },
            renderMessage(chat_history)
            {
                let self = this;
                let class_name_array = ['msg-chat-message'];
                switch (chat_history.type) {
                    case 'say':
                        if (this.ignored_client_list.hasOwnProperty(chat_history.username.toLowerCase())) {
                            return;
                        }
                        if (chat_history.bot || /^!/.test(chat_history.message)) {
                            if (this.bots_display_mode !== 'none') {
                                class_name_array.push('msg-bot');
                                if (this.bots_display_mode === 'greyed') {
                                    class_name_array.push('bot-greyed');
                                }
                            }
                        }
                        if (chat_history.role.toLowerCase() == 'admin') {
                            class_name_array.push('msg-admin-message');
                        }

                        let username = this.state.username;
                        let r = new RegExp('@' + username + '(?:$|[^a-z0-9_\-])', 'i');

                        if (username && chat_history.username != username && r.test(chat_history.message)) {
                            class_name_array.push('msg-highlight-message');
                        }

                        chat_history.time_string = utils.getTimeString(chat_history.time);
                        chat_history.message_html = Autolinker.link(self.escapeHTML(chat_history.message), {
                            mention: 'twitter',
                            truncate: 50,
                            replaceFn: self.replaceUsernameMentions
                        });

                        break;
                    case 'mute':
                        class_name_array = ['msg-mute-message'];
                        chat_history.username = `<${chat_history.username}>`;
                        break;
                    case 'unmute':
                        class_name_array = ['msg-mute-message'];
                        chat_history.username = `<${chat_history.username}>`;
                        break;
                    case 'error': break;
                    case 'info': break;
                    case 'client_message':
                        class_name_array.push('msg-info-message');
                        chat_history.message_html = chat_history.message;
                        break;
                    default: break;
                }

                chat_history.class_name = class_name_array.join(' ');

                return chat_history;
            },
            sendMessage(e)
            {
                if (this.state.user_class == 'DEMO') {
                    return;
                }
                if(e.keyCode == 13) {
                    let message = e.target.value;
                    message = message.trim();

                    if(!this.doCommand(message)){ // If not command was done is a message(or command) to the server
                        if(message.length >= 1 && message.length < this.chat_max_length) {
                            this.say(message);
                            e.target.value = '';
                        }
                    } else { // If a command was done erase the command text
                        e.target.value = '';
                    }
                }
            },

            // Returns true if a command was done, false if not
            doCommand(message)
            {
                // Check if is command
                let cmd_reg = /^\/([a-zA-z]*)\s*(.*)$/;
                let cmd_match = message.match(cmd_reg);
                if(!cmd_match) {
                    return;
                }
                let cmd  = cmd_match[1];
                let rest = cmd_match[2];
                switch(cmd) {
                    case 'ignore':
                        if(this.state.username === rest) {
                            this.showClientMessage("Can't ignore yourself");
                        } else if(this.isInvalidUsername(rest)) {
                            this.showClientMessage('Invalid Username');
                        } else if(!this.ignored_client_list.hasOwnProperty(rest.toLowerCase())) {
                            this.ignoreUser(rest);
                            this.showClientMessage('User ' + rest + ' ignored');
                        } else {
                            this.showClientMessage('User ' + rest + ' was already ignored');
                        }
                        return true;
                    case 'unignore':
                        if(this.isInvalidUsername(rest)) {
                            this.showClientMessage('Invalid Username');
                        } else if(this.ignored_client_list.hasOwnProperty(rest.toLowerCase())) {
                            this.approveUser(rest);
                            this.showClientMessage('User ' + rest + ' approved');
                        } else {
                            this.showClientMessage('User ' + rest + ' was already approved');
                        }
                        return true;
                    case 'ignored':
                        this.listMutedUsers();
                        return true;

                    default:
                        return false;
                }
            },
            say(message)
            {
                this.state.socket.ws.emit('send', message);
            },
            showClientMessage(message)
            {
                this.state.chat_messages.push({
                    time_string: utils.getTimeString(Date.now()),
                    type: 'client_message',
                    message: ' *** '+ message,
                });
            },
            ignoreUser(username)
            {
                this.ignored_client_list[username.toLowerCase()] = {username: username};
                try {
                    localStorage['ignored_client_list'] = JSON.stringify(this.ignored_client_list);
                } catch (e) {}
                this.updateChatMessages();
            },
            approveUser(username)
            {
                if (this.ignored_client_list[username.toLowerCase()]) {
                    delete this.ignored_client_list[username.toLowerCase()];
                    try {
                        localStorage['ignored_client_list'] = JSON.stringify(this.ignored_client_list);
                    } catch (e) {}
                    this.updateChatMessages();
                }
            },
            listMutedUsers()
            {
                let ignored_list_message = '';
                let ignored_client_list_arr = Object.keys(this.ignored_client_list);
                if (ignored_client_list_arr.length === 0) {
                    ignored_list_message = 'No users ignored';
                } else {
                    ignored_list_message = ignored_client_list_arr.join(', ');
                }
                // this.state.chat_messages.unshift(message);
                this.state.chat_messages.push({
                    time_string: utils.getTimeString(Date.now()),
                    type: 'client_message',
                    message: ignored_list_message
                });
                this.updateChatMessages();
            },
            isInvalidUsername(input)
            {
                if (typeof input !== 'string') return 'NOT_STRING';
                if (input.length === 0) return 'NOT_PROVIDED';
                if (input.length < 3) return 'TOO_SHORT';
                if (input.length > 50) return 'TOO_LONG';
                if (!/^[a-z0-9_\-]*$/i.test(input)) return 'INVALID_CHARS';
                if (input === '__proto__') return 'INVALID_CHARS';
                return false;
            },
            replaceUsernameMentions(match)
            {
                let self = this;

                // Use default handler for non-twitter links
                if (match.serviceName !== 'twitter') {
                    return true;
                }
                let username = match.matchedText;
                // return '<a href="/user/' + username.replace('@', '') +'" target="_blank">' + username + '</a>';
                return '<a href="javascript:void(0)">' + username + '</a>';
            },
            escapeHTML(str)
            {
                let entityMap = {
                    "&": "&amp;",
                    "<": "&lt;",
                    ">": "&gt;",
                    '"': '&quot;',
                    "'": '&#39;'
                };
                return String(str).replace(/[&<>"']/g, function (s) {
                    return entityMap[s];
                });
            },
        }
    }
</script>

<style scoped>

</style>
